import {Component, OnDestroy, OnInit} from '@angular/core';
import {CoreComponent} from '../core.component';
import {AlertService} from '../../service/alert.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SecurityService} from '../../service/security.service';
import {PublicService} from '../../service/public.service';
import {UserConfirmation} from '../../model/user-confirmation.model';
import {UserRecover} from '../../model/user-recover.model';
import {LoginMessage} from '../../message/login.message';
import {MessageService} from '../../service/message.service';
import {LogoutMessage} from '../../message/logout.message';
import {LoggerService} from "../../../service/logger.service";

@Component({
    selector: 'app-recover',
    templateUrl: './recover.component.html',
    standalone: false
})
export class RecoverComponent extends CoreComponent implements OnInit {

  model: UserRecover = new UserRecover();

  clearFormErrors(): Map<string, string> {
    return new Map<string, string>().set('email', '');
  }

  constructor(protected alert: AlertService,
              protected router: Router,
              protected messageService: MessageService,
              protected securityService: SecurityService,
              protected publicService: PublicService,
              protected loggerService: LoggerService) {
    super(alert, router, securityService, loggerService);
  }

  ngOnInit(): void {
    this.messageService.publish(new LogoutMessage(true));
  }

  recoverUser(): void {
    this.clearFormErrors();
    this.loading = true;
    this.publicService
      .recoverUser(this.model)
      .subscribe(
        completed => {
          this.alert.success('Solicitud enviada correctamente favor revisar su correo');
          this.loading = false;
          this.router.navigate(['/login']);
        },
        error => this.processError(error));

  }


}
